import React, { useEffect, useRef } from "react";
import Nouislider, { NouisliderProps } from "nouislider-react";
import "nouislider/distribute/nouislider.css";
import styles from "./progress-slider.module.scss";
interface ProgressSliderProps extends NouisliderProps {
  progress: number;
  disabled: boolean;
}
export const ProgressSlider: React.FC<ProgressSliderProps> = ({
  progress,
  disabled,
  ...props
}) => {
  const ref = useRef<any>(null);
  useEffect(() => {
    if (ref.current) {
      ref.current.noUiSlider.set(progress);
    }
  }, [progress]);
  useEffect(() => {
    if (ref.current) {
      if (disabled) {
        ref.current.setAttribute('disabled', true);
      } else {
        ref.current.removeAttribute('disabled');
      }
    }
  }, [disabled]);

  return (
    <Nouislider
      animate={false}
      connect={[true, false]}
      className={styles.slider}
      instanceRef={(instance) => {
        if (instance && !ref.current) {
          ref.current = instance;
        }
      }}
      {...props}
    />
  );
};
